import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableBody, TableRow, TableHead, Box } from '@mui/material';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import moment from 'moment';
import { TableContainerMaxHeight, TableCellHeaderStickyTop } from 'components/list/TableComponentsStyled';
import { Button, Dialog } from '@totalsoft/rocket-ui';

const FinancialProductStateHistoryModalComponent = ({ stateTransitions, closeModal }) => {
  const [t] = useTranslation();

  return (
    <Dialog
      open={true}
      fullWidth
      maxWidth='md'
      scroll={'body'}
      TransitionProps={{ exit: false }}
      closeButtonProps={{ sx: { display: 'none' } }}
      content={
        <CardNoResultsWrapper content={stateTransitions} mt={0}>
          <TableContainerMaxHeight>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCellHeaderStickyTop>{t('FinancialProduct.FinalState')}</TableCellHeaderStickyTop>
                  <TableCellHeaderStickyTop>{t('FinancialProduct.MomentOfTransition')}</TableCellHeaderStickyTop>
                  <TableCellHeaderStickyTop>{t('FinancialProduct.User')}</TableCellHeaderStickyTop>
                </TableRow>
              </TableHead>
              <TableBody>
                {stateTransitions.map(item => {
                  return (
                    <TableRow hover key={item.transitionId}>
                      <TableCell>{item.stateName}</TableCell>
                      <TableCell>{moment(item.momentOfTransition).format('DD.MM.YYYY')}</TableCell>
                      <TableCell>{item.userName}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainerMaxHeight>
        </CardNoResultsWrapper>
      }
      actions={
        <Box mb={1} mr={1}>
          <Button onClick={closeModal}>{t('Close')}</Button>
        </Box>
      }
    />
  );
};

FinancialProductStateHistoryModalComponent.propTypes = {
  stateTransitions: PropTypes.array.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default FinancialProductStateHistoryModalComponent;
